export {};
//# sourceMappingURL=IDataPoint.js.map